import { useState } from 'react';
import * as XLSX from 'xlsx';
import { Card, SectionTitle, Btn, FileUpload } from './UI';
import { loadRecruitingFile, refreshRecruiting } from '../lib/recruiting';
import { excelToISO } from '../lib/exportExcel';

const norm = (s) => String(s ?? '').trim().toLowerCase().replace(/ё/g, 'е').replace(/\s+/g, ' ');
// колонки: заголовок «Последние Маршрут» (U), «Последние Статус» (V), «Последние Этап подбора» (X) — по названию, иначе по букве
function parse(file) {
  return new Promise((resolve, reject) => {
    const rd = new FileReader();
    rd.onload = (e) => {
      try {
        const wb = XLSX.read(e.target.result, { type: 'binary', cellDates: false });
        const rows = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]], { header: 1, defval: '' });
        const hi = rows.findIndex(r => (r || []).some(v => norm(v) === 'id вакансии'));
        if (hi < 0) throw new Error('Не найдена строка заголовков (колонка «id вакансии»)');
        const h = rows[hi].map(norm);
        const find = (parts, fallback) => { const i = h.findIndex(x => parts.every(p => x.includes(p))); return i >= 0 ? i : fallback; };
        const c = {
          id: find(['id', 'вакансии'], 0), route: find(['маршрут'], 20), status: find(['последние', 'статус'], 21),
          stage: find(['этап подбора'], 23), reason: find(['причина приостановки'], 22),
          rec: find(['рекрутер'], 19), opened: find(['дата открытия'], 7),
        };
        const out = [];
        rows.slice(hi + 1).forEach(r => {
          if (!r || !r[c.id] || !String(r[c.route] || '').trim()) return;
          out.push({
            vacancy_id: String(r[c.id]).trim(), route: String(r[c.route]).trim(),
            status: String(r[c.status] || '').trim() || null, stage: String(r[c.stage] || '').trim() || null,
            reason: String(r[c.reason] || '').trim() || null, recruiter: String(r[c.rec] || '').trim() || null,
            opened: excelToISO(r[c.opened]) || null,
          });
        });
        resolve(out);
      } catch (err) { reject(err); }
    };
    rd.onerror = () => reject(new Error('Не удалось прочитать файл'));
    rd.readAsBinaryString(file);
  });
}

export default function RecruitingTab({ actorId }) {
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const [res, setRes] = useState(null);

  async function go() {
    if (!file) return;
    setBusy(true); setErr(''); setRes(null);
    try {
      const rows = await parse(file);
      if (!rows.length) throw new Error('В файле нет заявок с кодом маршрута');
      const r = await loadRecruitingFile(rows, actorId);
      setRes({ ...r, total: rows.length });
      setFile(null);
      refreshRecruiting();
    } catch (e) { setErr('Ошибка: ' + e.message); } finally { setBusy(false); }
  }

  return (
    <div>
      <SectionTitle>Заявки подбора</SectionTitle>
      <div style={{ background: 'var(--accent-light)', border: '1px solid #BDD7EE', borderRadius: 8, padding: '10px 14px', marginBottom: 12, fontSize: 12, color: 'var(--accent-dark)', lineHeight: 1.5 }}>
        Файл «Заявки подбора» (.xlsx). Берутся колонки: <b>id вакансии</b>, <b>Маршрут</b> (U), <b>Статус</b> (V), <b>Этап подбора</b> (X).
        В табеле у маршрута появится плашка «Подбор: статус · этап». Каждая загрузка полностью заменяет прежний список заявок.
      </div>
      <Card>
        <div style={{ padding: 16 }}>
          <FileUpload label="Файл «Заявки подбора» (.xlsx)" accept=".xlsx,.xls" onFile={setFile} hint="выгрузка из системы подбора" />
          {file && <div style={{ marginTop: 10, fontSize: 13, color: 'var(--text-muted)', marginBottom: 12 }}>📄 {file.name}</div>}
          {err && <div style={{ fontSize: 12, color: 'var(--red)', margin: '10px 0' }}>{err}</div>}
          {res && (
            <div style={{ fontSize: 12, margin: '10px 0', border: '1px solid #E2E8F0', borderRadius: 8, padding: '10px 12px', background: '#F8FAFC' }}>
              <div style={{ color: 'var(--green)', fontWeight: 600, marginBottom: 6 }}>✓ Загружено заявок: {res.inserted}; привязано к маршрутам: {res.matched}</div>
              {(res.unmatched || []).length > 0 && <div style={{ color: 'var(--red)' }}>Маршрут не найден в системе ({res.unmatched.length}): {res.unmatched.slice(0, 30).join(', ')}{res.unmatched.length > 30 ? ' …' : ''}</div>}
            </div>
          )}
          <div style={{ marginTop: 10 }}><Btn size="full" onClick={go} disabled={!file || busy}>{busy ? 'Загрузка...' : 'Загрузить'}</Btn></div>
        </div>
      </Card>
    </div>
  );
}
